var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "automation-templates-layout" }, [
    _c(
      "header",
      { staticClass: "automation-templates-layout__header" },
      [_vm._t("header")],
      2
    ),
    _vm._v(" "),
    _c("div", { staticClass: "automation-templates-layout__container" }, [
      _c(
        "aside",
        { staticClass: "automation-templates-layout__sidebar" },
        [_vm._t("sidebar")],
        2
      ),
      _vm._v(" "),
      _c(
        "main",
        { staticClass: "automation-templates-layout__main-content" },
        [_vm._t("default")],
        2
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }